var map = {
	"./pages/match-words/match-words.module.ngfactory": [
		"H/FW",
		0,
		16
	],
	"./pages/missing-letter/missing-letter.module.ngfactory": [
		"kY1c",
		0,
		17
	],
	"./pages/select-game/select-game.module.ngfactory": [
		"+2rp",
		0,
		18
	],
	"./pages/select-topic/select-topic.module.ngfactory": [
		"7OB+",
		0,
		19
	],
	"./pages/sentence-builder/sentence-builder.module.ngfactory": [
		"shrx",
		0,
		20
	],
	"./pages/story-builder/story-builder.module.ngfactory": [
		"CgTg",
		0,
		21
	]
};
function webpackAsyncContext(req) {
	if(!__webpack_require__.o(map, req)) {
		return Promise.resolve().then(function() {
			var e = new Error("Cannot find module '" + req + "'");
			e.code = 'MODULE_NOT_FOUND';
			throw e;
		});
	}

	var ids = map[req], id = ids[0];
	return Promise.all(ids.slice(1).map(__webpack_require__.e)).then(function() {
		return __webpack_require__(id);
	});
}
webpackAsyncContext.keys = function webpackAsyncContextKeys() {
	return Object.keys(map);
};
webpackAsyncContext.id = "zn8P";
module.exports = webpackAsyncContext;